// extracted by mini-css-extract-plugin
module.exports = {"videoPopup":"style_videoPopup__2QVlo","text":"style_text__3p5ca","author":"style_author__2pupx","watchNow":"style_watchNow__Ma2JK"};